import apiClient from '../client/api';

type JoinWaitlistResponse = {
  token: string;
  userId: string;
  userLevel: string;
};

type CreateMembershipPayload = {
  email: string;
  couponName: string;
  zipCode: string;
};

type MembershipResponse = {
  subscriptionId: string;
  clientSecret: string;
  type: string;
  finalAmount: number;
};

type ConfirmSubscriptionPayload = {
  subscriptionId: string;
};

type MembershipStatusResponse = {
  id: string;
  status: string;
  type: string;
  price: {
    amount: number;
    currency: string;
  };
  renewalDate: string;
  cancelAtPeriodEnd: boolean;
  paymentMethod: {
    id: string;
    type: string;
    billingDetails: {
      name: string;
      email: string;
      phone: string;
      address: {
        city: string;
        country: string;
        line1: string;
        line2: string;
        postalCode: string;
        state: string;
      };
    };
    brand: string;
    last4: string;
    country: string;
    funding: string;
    expiration: object;
  };
};

type MembershipPriceResponse = {
  id: string;
  amount: number;
  currency: string;
  defaultCoupon: string;
  createdAt: string;
  updatedAt: string;
  subtotal: number;
  total: number;
  discount: number;
  tax: number;
};

type GetPricePayloadType = {
  coupon?: string;
  zipCode?: string;
};

async function membership(payload: CreateMembershipPayload): Promise<MembershipResponse> {
  const response = await apiClient.post('/membership', payload);
  return response.data;
}

async function confirmSubscription(payload: ConfirmSubscriptionPayload) {
  const response = await apiClient.post('/membership/confirm', payload);
  return response.data;
}

async function membershipStatus(id: string): Promise<MembershipStatusResponse> {
  const response = await apiClient.get(`/membership/${id}`);
  return response.data;
}

async function cancelSubscription(id: string): Promise<MembershipStatusResponse> {
  const response = await apiClient.post(`/membership/${id}/cancel-auto-renewal`);
  return response.data;
}

async function renewSubscription(id: string): Promise<MembershipStatusResponse> {
  const response = await apiClient.post(`/membership/${id}/restart-auto-renewal`);
  return response.data;
}

async function getPrice(zipCode: string | null = null, coupon: string | null = null): Promise<MembershipPriceResponse> {
  const payload: GetPricePayloadType = {};
  if (zipCode) payload.zipCode = zipCode;
  if (coupon) payload.coupon = coupon;
  const response = await apiClient.post(`/membership/price`, payload);
  return response.data;
}

async function joinWaitlistV1(email: string, accessCode?: string | null): Promise<JoinWaitlistResponse> {
  const response = await apiClient.post(`v1/membership/waitlist`, { email, accessCode });
  return response.data;
}

export default {
  membership,
  confirmSubscription,
  membershipStatus,
  cancelSubscription,
  renewSubscription,
  getPrice,
  joinWaitlistV1,
};
